import script from "./ToolNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolNavigation.vue?vue&type=script&setup=true&lang=js"

import "./ToolNavigation.vue?vue&type=style&index=0&id=5cbb5fc0&scoped=true&lang=css"

import exportComponent from "/Users/ben/Local Sites/serenialife-public/app/public/wp-content/themes/serenialife-public-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cbb5fc0"]])

export default __exports__